module.exports = "https://thumbor.subcdn.com/imageView2/minio-activity/aha-browser/logo-large.png";